import Constant from "@/common/constant/Constant";
import RenderFieldUI from "../formManagement/RenderFieldUI";
import { useState, useEffect } from "react";
import Utils from '@/common/utils/utils';
import {
    isShowRealtimeModelField,
    isShowChatGptModelFieldForTelephone,
    isShowReasoningEffortFieldForTelephone,
    isShowReferenceKnowledgeField,
    isShowExecutionModeField,
    isShowExecutionScopeField,
    isShowApplicablePhoneNumberField,
    isShowVoiceSettingsField,
    isShowTimeExecutionFields,
    isShowTimeBasedDelayResponseField,
    isShowTriggerConditionField,
    isShowTimeExecutionPeriod
} from '../ticketList/handler/KnowledgeTicketHandler';

function WrapRenderFieldUI(props) {
    const [isDisplayField, setIsDisplayField] = useState(true);

    const filterFieldListData = (field, selectedFormDetail) => {
        const VARIANT_FORM_NEED_WRAP = [
            Constant.FORM_VARIANT.AI_TELEPHONE_PROMPT,
            Constant.FORM_VARIANT.AI_ASSISTANT_PROMPT
        ];
        if (!VARIANT_FORM_NEED_WRAP.includes(selectedFormDetail?.definitionVariant)) {
            return true;
        }

        // Get aiTelephoneSelectedData from props
        const aiTelephoneSelectedData = props.aiTelephoneSelectedData || {};

        switch (field.sysField) {
            // Trigger Condition: Only show when Prompt Type is already selected
            // This prevents race condition where trigger condition values are cleared
            // before prompt type field has been initialized
            case Constant.SYSTEM_FIELD.AI_TELEPHONE_TRIGGER_CONDITION: {
               return isShowTriggerConditionField(aiTelephoneSelectedData)
            }

            case Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_TIME_PERIOD:{
                return isShowTimeExecutionPeriod(aiTelephoneSelectedData)
            }


            // Time execution fields group
            case Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_START_TIME:
            case Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_START_DATE:
            case Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_END_TIME:
            case Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_END_DATE:
            case Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_DAY_OF_WEEKS:
                return isShowTimeExecutionFields(aiTelephoneSelectedData) && isShowTimeExecutionPeriod(aiTelephoneSelectedData);

            case Constant.SYSTEM_FIELD.AI_TELEPHONE_REALTIME_MODEL:
                return isShowRealtimeModelField(aiTelephoneSelectedData);

            case Constant.SYSTEM_FIELD.CHATGPT_MODEL: {
                return isShowChatGptModelFieldForTelephone(aiTelephoneSelectedData);
            }

            case Constant.SYSTEM_FIELD.REASONING_EFFORT: {
                // For AI Assistant form, don't unmount/remount reasoning effort field.
                // MenuTagInPutBase already handles its own visibility via isShowReasoningEffortField().
                // Unmounting causes re-initialization (queryFieldChild API call) which overrides
                // the correct default value set by the aiAutoSelectedData useEffect.
                if (selectedFormDetail?.definitionVariant === Constant.FORM_VARIANT.AI_ASSISTANT_PROMPT) {
                    return true;
                }
                return isShowReasoningEffortFieldForTelephone(aiTelephoneSelectedData);
            }
            case Constant.SYSTEM_FIELD.AI_TELEPHONE_REFERENCE_KNOWLEDGE:
                return isShowReferenceKnowledgeField(aiTelephoneSelectedData);

            case Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_MODE:
                return isShowExecutionModeField(aiTelephoneSelectedData);

            case Constant.SYSTEM_FIELD.AI_TELEPHONE_EXECUTION_SCOPE: {
                return isShowExecutionScopeField(aiTelephoneSelectedData);
            }

            case Constant.SYSTEM_FIELD.AI_TELEPHONE_APPLICABLE_PHONE_NUMBER: {
                // Field only shows when:
                // 1. Owner project has isPublic = true (EXTERNAL option is available)
                // 2. AND EXECUTION_SCOPE contains EXTERNAL
                // Note: If field becomes required in future, also update CreateTicketCommonHandler.js
                const ownerProjectDetail = props.affiliationProjectOfTicket || {};
                if (ownerProjectDetail?.isPublic !== true) {
                    return false;
                }
                return isShowApplicablePhoneNumberField(aiTelephoneSelectedData);
            }

            case Constant.SYSTEM_FIELD.AI_TELEPHONE_VOICE_SETTINGS:
                return isShowVoiceSettingsField(aiTelephoneSelectedData);

            case Constant.SYSTEM_FIELD.AI_TELEPHONE_TIME_BASED_DELAY_RESPONSE: {
                const isVisible = isShowTimeBasedDelayResponseField(aiTelephoneSelectedData);
                // Clear errors when field becomes hidden
                if (!isVisible && props.clearErrors) {
                    const fieldId = props.data?.id || props.name;
                    if (fieldId) {
                        props?.clearErrors(fieldId);
                    }
                }
                return isVisible;
            }

            default:
                return true;
        }
    };

    useEffect(() => {
        if (props.selectedFormDetail) {
            const result = filterFieldListData(
                { sysField: props.sysField },
                props.selectedFormDetail
            );
            if (result !== isDisplayField) {
                setIsDisplayField(result);
            }
        }
    }, [props.selectedFormDetail, props.aiTelephoneSelectedData]);

    return (
        <div>
            {isDisplayField && <RenderFieldUI {...props} />}
        </div>
    )
}

export default WrapRenderFieldUI;
